/* global jQuery, Astd */

export const $ = jQuery;
export const rootPath = Astd.rootPath || '';
